export default __webpack_public_path__ + "static/help_06_04-6-f1310ffdbb4fc3f5c6c3ce6695cfdfef.png";